// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1pp9O","noInteraction":"EventWrapper_noInteraction__Halth","pointerPassthrough":"EventWrapper_pointerPassthrough__1ywaF"};